import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsEdit: {
        id: "app.spaces.actions.edit.text",
        defaultMessage: "Edit Space",
    },
    updateSpacePrivacyStateSuccess: {
        id: "app.spaces.actions.privacy.update.success.text",
        defaultMessage: "Space's privacy status updated successfully.",
    },
    updateSpaceArchiveStateSuccess: {
        id: "app.spaces.actions.archive.update.success.text",
        defaultMessage: "Space's archive status updated successfully.",
    },
    updateSpaceFloorplanTitle: {
        id: "app.spaces.actions.floorplan.update.title.text",
        defaultMessage: "Upload floorplan",
    },
    updateSpaceFloorplanButton: {
        id: "app.spaces.actions.floorplan.update.button.text",
        defaultMessage: "Upload",
    },
    updateSpaceFloorplanSuccess: {
        id: "app.spaces.actions.floorplan.update.success.text",
        defaultMessage: "Space's floorplan updated successfully.",
    },
});
export default messages;
